// 099 D10 异常中心：失败/卡死/降级/需修订聚合，直达任务
// 反馈入口、满意度、处理状态流转均为「未采集」诚实态（处理状态修改属 D15 待批写操作）。
import { useState } from "react";
import { Link } from "react-router-dom";
import { ops } from "../../lib/api";
import { useOpsQuery } from "./useOpsQuery";
import { DaySeg, Note, Sect, fmtMoney, fmtTime } from "./widgets";

const TYPE_LABEL: Record<string, { label: string; cls: string }> = {
  failed: { label: "失败", cls: "t-red" },
  stuck: { label: "无进展", cls: "t-yellow" },
  degraded: { label: "降级", cls: "t-yellow" },
  needs_revision: { label: "需修订", cls: "t-yellow" },
};

export default function Issues() {
  const [days, setDays] = useState(7);
  const q = useOpsQuery(() => ops.exceptions(days), [days]);

  if (q.loading && !q.data) return <p className="muted">加载中…</p>;
  if (q.forbidden) return <p>🔒 {q.forbidden}</p>;
  if (q.error) return <p style={{ color: "var(--err)" }}>加载失败：{q.error}</p>;
  if (!q.data) return null;
  const d = q.data;
  const countOf = (t: string) => d.items.filter((i) => i.type === t).length;

  return (
    <>
      <h2 className="d-title">异常中心与朋友反馈</h2>
      <p className="d-sub2">可从异常直达对应项目与任务 · 查看不改变任何状态</p>

      <div className="d-filter">
        <DaySeg days={days} onChange={setDays} />
        <span className="d-tz">时区 {d.range.timezone}</span>
        <span className="d-updated">更新于 <b>{new Date(d.range.updatedAt).toLocaleString("zh-CN", { timeZone: "Asia/Shanghai", hour12: false })}</b></span>
      </div>

      <div className="d-grid d-kpis" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(190px,1fr))" }}>
        <div className="d-card d-kpi bad"><div className="k">失败任务</div><div className="v">{countOf("failed")}</div><div className="d flat">范围内</div></div>
        <div className="d-card d-kpi warn"><div className="k">长时间无进展</div><div className="v">{countOf("stuck")}</div><div className="d flat">&gt; 30 分钟无心跳</div></div>
        <div className="d-card d-kpi"><div className="k">降级执行</div><div className="v">{countOf("degraded")}</div><div className="d flat">如配图占位图</div></div>
        <div className="d-card d-kpi"><div className="k">内容需修订</div><div className="v na">未采集</div><div className="d flat">质量字段随 harness v2 上线</div></div>
        <div className="d-card d-kpi"><div className="k">满意度 👍/👎</div><div className="v na">未采集</div><div className="d flat">{d.satisfaction.note}</div></div>
      </div>

      <Sect title="异常列表" tag="D10" />
      <div className="d-tblwrap">
        <table>
          <thead><tr><th>类型</th><th>用户</th><th>项目</th><th>步骤</th><th>时间</th><th>错误摘要（已脱敏）</th><th></th></tr></thead>
          <tbody>
            {d.items.map((it, i) => {
              const t = TYPE_LABEL[it.type] ?? { label: it.type, cls: "t-gray" };
              return (
                <tr key={`${it.jobId}-${it.type}-${i}`}>
                  <td><span className={`tag ${t.cls}`}>{t.label}</span></td>
                  <td>{it.ownerEmail ?? "—"}</td>
                  <td>{it.projectName ?? it.projectId.slice(0, 8)}</td>
                  <td>{it.step ?? "—"}</td>
                  <td className="small">{fmtTime(it.time)}</td>
                  <td className="small">{it.summary}</td>
                  <td><Link to={`/dashboard/projects/${it.projectId}`} className="d-chip">直达项目 ›</Link></td>
                </tr>
              );
            })}
            {!d.items.length && <tr><td colSpan={7} className="muted">范围内无异常 🎉</td></tr>}
          </tbody>
        </table>
      </div>
      <Note>
        {d.statusTracking.note}。错误摘要已剥 URL/token/长随机串；日成本预算阈值 {fmtMoney(d.budget.thresholdCents)}（预警见「生成与成本」）。
      </Note>

      <Sect title="朋友反馈" tag="D10" hint="闭环状态：待看/已复现/已修复/已回复" />
      <div className="d-card">
        <p className="muted" style={{ margin: 0 }}>
          <strong>反馈入口未采集</strong>——{d.feedback.note}。接入后本区展示：项目/任务 ID · 问题描述 · 发生时间 · 截图说明，
          状态仅表示处理进度，不自动向朋友发送消息。
        </p>
      </div>
    </>
  );
}
